import { TimeTraker } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class TimeTrakerService {

	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(TimeTraker);
	}

	getNew(): any {
		return this.repository.getNewEntity();
	}

	find(id: number) {
		if (id === undefined) return; 
		return this.repository.find(`gettasktimetrakerdetails?id=${id}`);
	}

	findOne(id: number) {
		if (id === undefined) return;
		return this.repository.find(`gettasktimetrakerforupdate?id=${id}`);
	}
} 